import { SessionFilterViewProps } from './model'
import React, { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  selectSessionFilterMeetingKind,
  selectSessionFilterMeetingSources,
  setSessionFilterMeetingKind,
  setSessionFilterMeetingSources,
} from '../../store/sessionFilter/sessionFilter'
import { MultiSelectDropdown } from '../MultiSelectDropdown/MultiSelectDropdown'
import { useDebouncedCallback } from 'use-debounce'
import { useSearchParams } from 'react-router-dom'

export const SessionKindSourceFilter: React.FC<SessionFilterViewProps> = ({ disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const selectedMeetingKind = useAppSelector(selectSessionFilterMeetingKind)
  const selectedMeetingSource = useAppSelector(selectSessionFilterMeetingSources)
  const filterCount = (selectedMeetingKind ? 1 : 0) + selectedMeetingSource.length
  const kindOptions = [{ id: 'internal', label: 'In person' }]
  const [searchParams, setSearchParams] = useSearchParams()

  const sourceOptions = [
    { id: 'import', label: 'Import' },
    { id: 'zoom', label: 'Zoom' },
    { id: 'teams', label: 'Microsoft Teams' },
    { id: 'meet', label: 'Google Meet' },
  ]

  const handleMeetingSourceChanged = useDebouncedCallback((options: string[]) => {
    const kind = options.find((option) => kindOptions.map((kindOption) => kindOption.id).includes(option))
    const sources = options.filter((option) => sourceOptions.map((sourceOption) => sourceOption.id).includes(option))
    searchParams.delete('filterId')
    kind ? searchParams.set('meetingKind', kind) : searchParams.delete('meetingKind')
    dispatch(setSessionFilterMeetingKind(kind ?? null))
    sources.length > 0 ? searchParams.set('meetingSources', JSON.stringify(sources)) : searchParams.delete('meetingSources')
    dispatch(setSessionFilterMeetingSources(sources))
    onFilterChanged && onFilterChanged(searchParams)
  }, 400)

  const selectedOptions = useMemo(() => {
    const newSelectedOptions: string[] = []
    if (selectedMeetingKind) {
      newSelectedOptions.push(selectedMeetingKind)
    }
    selectedMeetingSource.forEach((source) => {
      newSelectedOptions.push(source)
    })
    return newSelectedOptions
  }, [selectedMeetingKind, selectedMeetingSource])

  return (
    <div>
      <div className='mb-1'>Filter by meeting source {filterCount ? <>({filterCount})</> : null}</div>
      <div className='d-flex gap-2'>
        <MultiSelectDropdown
          name='meetingSources'
          options={[...kindOptions, ...sourceOptions]}
          initialSelectedOptions={selectedOptions}
          onSelectedChanged={handleMeetingSourceChanged}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
